<script setup lang="ts">
import { NAlert, NSpin } from 'naive-ui';
import type { SignatureStepState } from '@/types/contractManagement/signatureFlow';

defineProps<{
  state: SignatureStepState<unknown>;
  requestPreview?: unknown;
}>();
</script>

<template>
  <div class="debug-panel">
    <NSpin :show="state.loading">
      <div class="status-stack">
        <NAlert v-if="state.error" type="error" :show-icon="true" title="Request failed">
          {{ state.error }}
        </NAlert>
      </div>
    </NSpin>
  </div>
</template>

<style scoped>
.debug-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.status-stack {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
